var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounCalendar2080587222222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1027.2,140.4h-51.6v-12c0-55.2-44.4-99.6-99.6-99.6c-55.2,0-99.6,44.4-99.6,99.6v12h-78v-12 c0-55.2-44.4-99.6-99.6-99.6c-55.2,0-99.6,44.4-99.6,99.6v12h-78v-12c0-55.2-44.4-99.6-99.6-99.6c-55.2,0-99.6,44.4-99.6,99.6v12 h-51.6c-67.2,0-121.2,54-121.2,121.2v786c0,67.2,54,121.2,121.2,121.2h854.4c67.2,0,121.2-54,121.2-121.2l0-784.8 C1148.4,195.6,1094.4,140.4,1027.2,140.4L1027.2,140.4z M840,129.6c0-20.4,16.8-36,36-36s36,16.8,36,36V216c0,20.4-16.8,36-36,36 s-36-16.8-36-36V129.6z M564,129.6c0-20.4,16.8-36,36-36c20.4,0,36,16.8,36,36V216c0,20.4-16.8,36-36,36c-20.4,0-36-16.8-36-36 V129.6z M286.8,129.6c0-20.4,16.8-36,36-36s36,16.8,36,36V216c0,20.4-16.8,36-36,36s-36-16.8-36-36V129.6z M1086,1048.8 c0,32.4-26.4,58.8-58.8,58.8H172.8c-32.4,0-58.8-26.4-58.8-58.8v-636h970.8v636H1086z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.6,722.4h123.6c16.8,0,31.2-14.4,31.2-31.2l0-124.8c0-16.8-14.4-31.2-31.2-31.2H267.6 c-16.8,0-31.2,14.4-31.2,31.2v124.8C236.4,708,250.8,722.4,267.6,722.4L267.6,722.4z M298.8,597.6h60v61.2h-60V597.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.8,722.4h123.6c16.8,0,31.2-14.4,31.2-31.2V566.4c0-16.8-14.4-31.2-31.2-31.2H538.8 c-16.8,0-31.2,14.4-31.2,31.2v124.8C506.4,708,520.8,722.4,538.8,722.4z M570,597.6h60v61.2h-60V597.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M808.8,722.4h123.6c16.8,0,31.2-14.4,31.2-31.2V566.4c0-16.8-14.4-31.2-31.2-31.2H808.8 c-16.8,0-31.2,14.4-31.2,31.2v124.8C777.6,708,792,722.4,808.8,722.4z M840,597.6h60v61.2h-60V597.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.6,988.8h123.6c16.8,0,31.2-14.4,31.2-31.2l0-124.8c0-16.8-14.4-31.2-31.2-31.2H267.6 c-16.8,0-31.2,14.4-31.2,31.2v124.8C236.4,974.4,250.8,988.8,267.6,988.8L267.6,988.8z M298.8,864h60v61.2h-60V864z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.8,988.8h123.6c16.8,0,31.2-14.4,31.2-31.2V832.8c0-16.8-14.4-31.2-31.2-31.2H538.8 c-16.8,0-31.2,14.4-31.2,31.2v124.8C506.4,974.4,520.8,988.8,538.8,988.8z M570,864h60v61.2h-60V864z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M808.8,988.8h123.6c16.8,0,31.2-14.4,31.2-31.2V832.8c0-16.8-14.4-31.2-31.2-31.2H808.8 c-16.8,0-31.2,14.4-31.2,31.2v124.8C777.6,974.4,792,988.8,808.8,988.8z M840,864h60v61.2h-60V864z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounCalendar2080587222222);
export default __webpack_public_path__ + "static/media/noun-calendar-2080587-222222.13f9b1b48d4d4f98982a37ec9610c604.svg";
export { ForwardRef as ReactComponent };